export const IMAGE_SIZE = {
  THUMBNAIL: 180,
};
